function PaymentTable({ payments, loading }) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="admin-loader"></div>
      </div>
    );
  }

  if (!payments || payments.length === 0) {
    return (
      <div className="empty-state">
        <p className="empty-state-description">Платежи не найдены</p>
      </div>
    );
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'completed':
        return 'badge badge-success';
      case 'pending':
        return 'badge badge-warning';
      case 'failed':
        return 'badge badge-danger';
      case 'cancelled':
        return 'badge badge-gray';
      default:
        return 'badge badge-gray';
    }
  };

  const getStatusText = (status) => {
    const statusMap = {
      completed: 'Завершен',
      pending: 'В обработке',
      failed: 'Ошибка',
      cancelled: 'Отменен',
    };
    return statusMap[status] || status;
  };

  return (
    <div className="overflow-x-auto">
      <table>
        <thead>
          <tr>
            <th>ID транзакции</th>
            <th>Пользователь</th>
            <th>Провайдер</th>
            <th>Сумма</th>
            <th>Статус</th>
            <th>Дата</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment) => (
            <tr key={payment.id}>
              <td className="font-mono text-xs text-gray-600">
                {payment.transaction_id.substring(0, 20)}...
              </td>
              <td>
                <div className="font-medium text-gray-900">
                  {payment.first_name} {payment.last_name}
                </div>
                <div className="text-xs text-gray-500">@{payment.username || 'N/A'}</div>
              </td>
              <td>
                <span className="badge badge-info">
                  {payment.payment_provider.toUpperCase()}
                </span>
              </td>
              <td className="font-semibold text-gray-900">
                {parseFloat(payment.amount).toLocaleString()} {payment.currency}
              </td>
              <td>
                <span className={getStatusBadge(payment.status)}>
                  {getStatusText(payment.status)}
                </span>
              </td>
              <td className="text-gray-600">
                {new Date(payment.created_at).toLocaleString('ru-RU', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PaymentTable;

